import React from "react";
import { Star } from "lucide-react";

/**
 * Note Google affichée avec sa source : le lien permet à quiconque de vérifier.
 * C'est ce qui distingue une note affichable d'une allégation invérifiable.
 *
 * À METTRE À JOUR À LA MAIN quand la note évolue : ces valeurs sont relevées
 * sur la fiche, elles ne sont pas récupérées automatiquement.
 * Dernier relevé : 5 août 2026.
 */
export const NOTE = "4,2";
export const NB_AVIS = 11;
export const LIEN_FICHE = "https://maps.app.goo.gl/xQ5BERBaeQsyFwFcA";

const NoteGoogle = ({ className = "", taille = "normale" }) => {
  const etoile = taille === "grande" ? "h-6 w-6" : "h-5 w-5";
  const texte = taille === "grande" ? "text-lg" : "text-sm";

  return (
    <a
      href={LIEN_FICHE}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex flex-wrap items-center gap-2 min-h-[44px] group ${className}`}
      aria-label={`Note de ${NOTE} sur 5 sur ${NB_AVIS} avis Google, voir la fiche`}
    >
      <span className="flex items-center" aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
          <Star key={i} className={`${etoile} text-yellow-500`} fill="currentColor" />
        ))}
        <Star className={`${etoile} text-yellow-500 opacity-40`} fill="currentColor" />
      </span>
      <span className={`${texte} text-gray-900 font-semibold`}>{NOTE}/5</span>
      <span className={`${texte} text-gray-700 group-hover:text-orange-700 underline`}>
        sur {NB_AVIS} avis Google
      </span>
    </a>
  );
};

export default NoteGoogle;
